module.exports = __webpack_public_path__ + "static/media/range-slider.25b1f7c7.svg";